import React from 'react';
import { TextLG, TextMDRegular } from 'styleguide/Texts';
import { View } from 'styleguide/View';
import { Spacing } from 'styleguide/spacing';
import DownloadAppstore from 'assets/download-appstore.svg';
import DownloadGooglePlay from 'assets/download-googleplay.svg';
import { Card } from 'styleguide/Card';

export const RoutineDetailHevyCTACard = () => {
  return (
    <Card style={{ padding: Spacing.lg }}>
      <View style={{ alignItems: 'center' }}>
        <TextLG style={{ paddingBottom: Spacing.sm }}>Save Routine</TextLG>
        <TextMDRegular style={{ paddingBottom: Spacing.md, textAlign: 'center' }} type="secondary">
          To save this routine and track your workouts, download Hevy for free.
        </TextMDRegular>
        <View
          style={{
            flexDirection: 'row',
            justifyContent: 'space-between',
            marginBottom: Spacing.md,
          }}
        >
          <a href="https://hevyapp.app.link/1TLxztjk2db">
            <DownloadAppstore />
          </a>
          <a href="https://hevyapp.app.link/d1yXlPlk2db">
            <DownloadGooglePlay />
          </a>
        </View>
      </View>
    </Card>
  );
};
